import { defDatetimeRangeFilter } from "helpers/date";
import { defaultConstants, defaultReducer, deletedFilters } from "helpers/reduxState";
import { combineReducers } from "redux";
import { ReduxCompatibleReducer } from "redux-actions";
import bgTasks from "./bgTasks";
import carChats from "./carChats";
import chats from "./chats";
import configs from "./configs";
import dictionaries from "./dictionaries";
import fuelCards from "./fuelCards";
import layout from "./layout";
import map from "./map";
import modal from "./modal";
import notifications from "./notifications";
import profile from "./profile";

const defaultReducers = {
    bids: {
        orderBy: ["firstBidPointPlanEnterDate desc"],
        preparedFilter: { and: { isDeleted: false } },
        customFilters: { isDeleted: false },
    },
    sharedbids: {},
    drivers: deletedFilters(),
    trucks: deletedFilters(),
    trailers: deletedFilters(),
    trackers: {},
    cargoowners: deletedFilters(),
    calculationqueues: {},
    allusers: {},
    userlogs: { ...defDatetimeRangeFilter("date") },
    admindrivers: deletedFilters(),
    adminorganizations: deletedFilters(),
    logists: {},
    routetemplates: {},
    distributionbids: { preparedFilter: { and: { isDeleted: false } }, customFilters: { isDeleted: false } },
    custompoints: {},
    "item-change-points": {},
    organizationcatalogs: deletedFilters(),
    organizationcatalogitems: deletedFilters(),
    counterpartypoints: {},
    "select-item-change-points": {},
    scenarios: {},
    trackersinfo: {},
    trackerhistory: {},
    transportcolumns: deletedFilters(),
    couplings: {},
    news: {},
    expenses: {},
    "suitable-distribution-bids": {},
    "blocked-emails": {},
    "admin-tariffs": deletedFilters(),
    "distribution-bid-sources": {},
    "trip-scenarios": {},
    "counterparty-contracts": {},
    "system-catalogs": {},
    "admin-fix-route-bids": {},
    "organization-fix-route-bids": {},
    "neural-network-logs": { ...defDatetimeRangeFilter("date") },
    "organization-recommendations": {},
    "mobile-app-ratings": {},
    "notification-queues": { ...defDatetimeRangeFilter("sentAt") },
    tasks: {},
    "kanban-tasks": {},
    "legal-persons": deletedFilters(),
    popups: {},
    "platon-points": {},
    "emergency-area-points": {},
    "user-platform-news": {},
    "admin-platform-news": {},
    "payment-points": {},
    "emulated-segments-logs": {},
    "preserved-tracker-logs": {},
    "popup-templates": {},
    "feedback-tags": {},
    "users-groups": {},
    "users-group-cars": {}, // cars in one group
    "users-groups-cars": {}, // all cars in all groups
    "users-group-users": {},
    "unstable-zones": {},
    "region-drying-periods": deletedFilters(),
    "admin-insolvency-registry": {},
    "admin-access-permits": {},
    "integration-clients": {},
    "access-permits": {},
    "admin-parcel-statuses": {},
    "document-templates": {},
    "document-tracking": {
        orderBy: ["lastParcelFixedAt desc"],
        preparedFilter: { and: [{ isDeleted: false }] },
        customFilters: { isDeleted: false },
    },
    "classification-types": {},
    "logist-history": {},
    "finances-invoice": {},
    "finances-contract": {},
    "finances-acceptance-certificate": {},
    "finances-acceptance-certificate-invoice": {},
    "finances-universal-transfer-documents": {},
    "finances-registries": {},
    "finances-bid-documents": {},
    "finances-distribution-bid-documents": {},
    "postamat-points": {},
    "hired-trailers": {},
    "hired-cars": {},
    "hired-drivers": {},
    "route-control-points": deletedFilters(),
    "trip-sheets": {},
    "shipping-orders": { orderBy: ["orderDate desc"] },
    waybills: { orderBy: ["billDate desc"] },
};

type ReducerKeys = keyof typeof defaultReducers;

function createDefaultReducers() {
    const reducersList: { [x: string]: ReduxCompatibleReducer<{}, {}> } = {};
    for (const key in defaultReducers) {
        reducersList[key] = defaultReducer(
            defaultConstants(key.toUpperCase()),
            defaultReducers[key as ReducerKeys],
            key,
        );
    }
    return reducersList;
}

export default combineReducers({
    layout,
    profile,
    map,
    modal,
    bgTasks,
    chats,
    dictionaries,
    "car-chats": carChats,
    configs,
    notifications,
    fuelCards,
    ...createDefaultReducers(),
});
